function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { renderDate, toIndianRs, truncateText } from "../../../../utils/helpers";
import ReactGA from "react-ga4";
import { cart, check, Coin } from "./svg";
import { toast } from "react-toastify";
import { isAdani } from "../../../../utils/isClient";
import "./style.css";
import Fireworks from "../../../Common/FireWorks";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function DealsLayout(_ref) {
  var _redux$preLoginWebvie, _redux$webView, _redux$auth, _redux$auth2, _redux$userId, _redux$auth3, _redux$isAuthenticate, _redux$auth4, _config$deals, _config$deals2;
  var id = _ref.id,
    title = _ref.title,
    endDate = _ref.endDate,
    displayImageUrl = _ref.displayImageUrl,
    vendorLogoUrl = _ref.vendorLogoUrl,
    vendorName = _ref.vendorName,
    brandName = _ref.brandName,
    hideVendorLogo = _ref.hideVendorLogo,
    fromProductPage = _ref.fromProductPage,
    productMrp = _ref.productMrp,
    productConvenienceFee = _ref.productConvenienceFee,
    productShippingFee = _ref.productShippingFee,
    points = _ref.points,
    thumbnailImageUrl = _ref.thumbnailImageUrl,
    tags = _ref.tags,
    categoryName = _ref.categoryName,
    isRewards = _ref.isRewards,
    isPoints = _ref.isPoints,
    rewardStorePoint = _ref.rewardStorePoint,
    className = _ref.className,
    isCustom = _ref.isCustom,
    config = _ref.config,
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    _ref$router = _ref.router,
    router = _ref$router === void 0 ? {} : _ref$router,
    cmsClient = _ref.cmsClient,
    winnreAuth = _ref.winnreAuth,
    winnreNoAuth = _ref.winnreNoAuth;
  var preLoginWebview = (_redux$preLoginWebvie = redux === null || redux === void 0 ? void 0 : redux.preLoginWebview) !== null && _redux$preLoginWebvie !== void 0 ? _redux$preLoginWebvie : redux === null || redux === void 0 || (_redux$webView = redux.webView) === null || _redux$webView === void 0 ? void 0 : _redux$webView.preLoginWebview;
  var history = (router === null || router === void 0 ? void 0 : router.history) || {
    push: function push() {},
    replace: function replace() {}
  };
  var location = (router === null || router === void 0 ? void 0 : router.location) || {
    search: "",
    pathname: ""
  };
  var dispatch = redux === null || redux === void 0 ? void 0 : redux.dispatch;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    itemAdded = _useState2[0],
    setItemAdded = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    disableCart = _useState4[0],
    setDisableCart = _useState4[1];
  var totalRewardspoint = isPoints ? redux === null || redux === void 0 || (_redux$auth = redux.auth) === null || _redux$auth === void 0 ? void 0 : _redux$auth.reloyRewardPoints : redux === null || redux === void 0 || (_redux$auth2 = redux.auth) === null || _redux$auth2 === void 0 || (_redux$auth2 = _redux$auth2.redux) === null || _redux$auth2 === void 0 || (_redux$auth2 = _redux$auth2.auth) === null || _redux$auth2 === void 0 ? void 0 : _redux$auth2.rewardPoints;
  var fontBodyClass = isAdani(config) && config !== null && config !== void 0 && config.applyClientFonts ? (config === null || config === void 0 ? void 0 : config.fontBody) || '' : '';

  // console.log('total rewards from deal layout', totalRewardspoint);
  var openLoginModal = function openLoginModal() {
    var _redux$authActions;
    if (dispatch && redux !== null && redux !== void 0 && (_redux$authActions = redux.authActions) !== null && _redux$authActions !== void 0 && _redux$authActions.openLoginModal) {
      dispatch(redux.authActions.openLoginModal());
    }
  };
  var userId = (_redux$userId = redux === null || redux === void 0 ? void 0 : redux.userId) !== null && _redux$userId !== void 0 ? _redux$userId : redux === null || redux === void 0 || (_redux$auth3 = redux.auth) === null || _redux$auth3 === void 0 ? void 0 : _redux$auth3.userId;
  var isAuthenticated = (_redux$isAuthenticate = redux === null || redux === void 0 ? void 0 : redux.isAuthenticated) !== null && _redux$isAuthenticate !== void 0 ? _redux$isAuthenticate : redux === null || redux === void 0 || (_redux$auth4 = redux.auth) === null || _redux$auth4 === void 0 ? void 0 : _redux$auth4.isAuthenticated;
  var isPriceDrop = Array.isArray(tags) && tags.some(function (tag) {
    return (tag === null || tag === void 0 ? void 0 : tag.name) === "Price Drop Sale";
  });
  console.log("isPriceDrop", isPriceDrop, tags);
  var formattedPoints = Number(points || 0).toLocaleString("en-IN");
  var rewardsRouteBase = isRewards === true && isPoints === true ? "/rewardPointStore" : "/rewardStore";
  var dealClickedHandler = function dealClickedHandler() {
    var _cmsClient$defaults, _cmsClient$defaults2;
    if ((cmsClient === null || cmsClient === void 0 || (_cmsClient$defaults = cmsClient.defaults) === null || _cmsClient$defaults === void 0 ? void 0 : _cmsClient$defaults.baseURL) === "https://prod.loyalie.in" || (cmsClient === null || cmsClient === void 0 || (_cmsClient$defaults2 = cmsClient.defaults) === null || _cmsClient$defaults2 === void 0 ? void 0 : _cmsClient$defaults2.baseURL) === "https://uat.loyalie.in") {
      // window.fbq("trackCustom", "GrabOfferButtonClicked"); redo
    }
    ReactGA.event({
      category: "OFFER",
      action: "GRAB OFFER CLICKED",
      label: "GRAB OFFER BUTTON"
    });
    var valueToSend = {
      message: "OPEN_LOGIN"
    };
    console.log({
      isAuthenticated: isAuthenticated,
      winnreAuth: winnreAuth,
      preLoginWebview: preLoginWebview
    });
    if (!isAuthenticated && preLoginWebview) {
      var _window, _window2;
      // console.log('app login');
      (_window = window) === null || _window === void 0 || (_window = _window.webkit) === null || _window === void 0 || (_window = _window.messageHandlers) === null || _window === void 0 || _window.jsMessageHandler.postMessage(valueToSend);
      (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.JSBridge) === null || _window2 === void 0 || _window2.showMessageInNative("OPEN_LOGIN");
      return;
    }
    if (isAuthenticated) {
      winnreAuth === null || winnreAuth === void 0 || winnreAuth({
        method: "POST",
        url: "winnre/user/deals/trackClick?dealId=".concat(id, "&userId=").concat(userId)
      }).then(function () {})["catch"](function () {});
    } else {
      winnreNoAuth === null || winnreNoAuth === void 0 || winnreNoAuth({
        method: "POST",
        url: "winnre/user/deals/trackClick?dealId=".concat(id)
      }).then(function () {})["catch"](function () {});
    }
    if (isAuthenticated) {
      var routePath = isRewards === true ? "".concat(rewardsRouteBase, "/").concat(id) : isCustom ? "/curated/".concat(id) : "/deals/".concat(id);
      // Record where we came from so the details page can return here.
      history.push(routePath, {
        from: "".concat((location === null || location === void 0 ? void 0 : location.pathname) || "").concat((location === null || location === void 0 ? void 0 : location.search) || "")
      });
    } else {
      var _routePath = isRewards === true ? rewardsRouteBase : isCustom ? "/curated" : "/deals";
      if (fromProductPage) {
        var separator = location.search ? "&" : "?";
        history.push("".concat(location.pathname).concat(location.search).concat(separator, "postLoginUrl=").concat(_routePath, "/").concat(id));
      } else {
        history.push("".concat(_routePath, "?postLoginUrl=").concat(_routePath, "/").concat(id));
      }
      openLoginModal();
    }
  };

  // On cart click

  var OnCartClick = function OnCartClick() {
    var _window3, _cartData, _cartData2, _redux$dealAction;
    (_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.webengage) === null || _window3 === void 0 || _window3.track("AddToCartClicked", {
      category: "".concat(categoryName),
      ProductName: "".concat(title),
      Price: "".concat(productMrp),
      PointsRequired: "".concat(points)
    });
    var oldCartData = isPoints ? localStorage.getItem("cartData_reloyrewardpoints") : localStorage.getItem("cartData");
    var currentMrp = 0;
    var totalCartCount = 0;
    var totalShippingFee = 0;
    var totalConvenienceFee = 0;
    var totalPoints = 0;
    var cartData = {
      cartValues: [],
      totalMrp: currentMrp,
      totalPoints: totalPoints,
      totalShippingFee: totalShippingFee,
      totalConvenienceFee: totalConvenienceFee,
      totalProduct: totalCartCount
    };
    if (oldCartData) {
      cartData = JSON.parse(oldCartData);
    }
    console.log("currentPoints", points, "cartTotal", (_cartData = cartData) === null || _cartData === void 0 ? void 0 : _cartData.totalPoints, "rewardsTotal", totalRewardspoint);
    if (totalRewardspoint >= 0 && points + ((_cartData2 = cartData) === null || _cartData2 === void 0 ? void 0 : _cartData2.totalPoints) > totalRewardspoint) {
      setDisableCart(true);
      toast("You don't have enough reward points to redeem this item.");
      return;
    }
    handleClick();
    // Add the new product to cartValues
    cartData.cartValues.push({
      id: id,
      title: title,
      endDate: endDate,
      displayImageUrl: displayImageUrl,
      vendorLogoUrl: vendorLogoUrl,
      productMrp: productMrp,
      thumbnailImageUrl: thumbnailImageUrl,
      points: points,
      productShippingFee: productShippingFee,
      productConvenienceFee: productConvenienceFee,
      tags: tags
    });

    // Update totalMrp and totalProduct
    cartData.totalMrp += productMrp;
    cartData.totalShippingFee += productShippingFee;
    cartData.totalConvenienceFee += productConvenienceFee;
    cartData.totalProduct += 1;
    cartData.totalPoints += points;

    // Save updated cart data to localStorage
    if (isPoints) {
      localStorage.setItem("cartData_reloyrewardpoints", JSON.stringify(cartData));
    } else {
      localStorage.setItem("cartData", JSON.stringify(cartData));
    }
    // Dispatch a custom event to notify other components
    if (dispatch && redux !== null && redux !== void 0 && (_redux$dealAction = redux.dealAction) !== null && _redux$dealAction !== void 0 && _redux$dealAction.setCartModalVisible) {
      dispatch(redux.dealAction.setCartModalVisible(true));
    }
    window.dispatchEvent(new Event("cartUpdated"));
    // const state = store.getState(); // Access the current store state
    // const isRefresh = !state.deals.isRefreshRewards;
    // dispatch(dealAction.setIsRewardRefreshing(isRefresh));
    console.log(cartData);
  };
  var handleClick = function handleClick() {
    if (!itemAdded) {
      setItemAdded(true);
      setTimeout(function () {
        var _ref2, _ref3, _dealsState$isRefresh, _redux$dealAction2, _redux$dealAction3;
        setItemAdded(false);
        var dealsState = (redux === null || redux === void 0 ? void 0 : redux.deals) || (redux === null || redux === void 0 ? void 0 : redux.deal) || {};
        var isRefresh = !((_ref2 = (_ref3 = (_dealsState$isRefresh = dealsState === null || dealsState === void 0 ? void 0 : dealsState.isRefreshRewards) !== null && _dealsState$isRefresh !== void 0 ? _dealsState$isRefresh : dealsState === null || dealsState === void 0 ? void 0 : dealsState.isRewardRefreshing) !== null && _ref3 !== void 0 ? _ref3 : redux === null || redux === void 0 ? void 0 : redux.isRefreshRewards) !== null && _ref2 !== void 0 ? _ref2 : redux === null || redux === void 0 ? void 0 : redux.isRewardRefreshing);
        console.log({
          redux: redux,
          dealsState: dealsState,
          isRefresh: isRefresh,
          test: redux === null || redux === void 0 || (_redux$dealAction2 = redux.dealAction) === null || _redux$dealAction2 === void 0 ? void 0 : _redux$dealAction2.setIsRewardRefreshing
        });
        // Skip the rewards re-fetch for the coin store (isPoints) flow.
        // The points list is not filtered by affordability (see getRewards in
        // DealsAndDiscounts/data.js), so re-fetching after redeem does no
        // useful work and, because that flow appends results, it duplicates
        // the products. Other flows still refresh normally.
        if (!isPoints && dispatch && redux !== null && redux !== void 0 && (_redux$dealAction3 = redux.dealAction) !== null && _redux$dealAction3 !== void 0 && _redux$dealAction3.setIsRewardRefreshing) {
          dispatch(redux.dealAction.setIsRewardRefreshing(isRefresh));
        }
      }, 2000); // Reset after 2 seconds
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      onClick: dealClickedHandler,
      className: " shadow-lg  hover:shadow-xl flex-none cursor-pointer ".concat(fontBodyClass, " h-auto ").concat(isPoints ? "border rounded-t-2xl rounded-b-lg ".concat(config !== null && config !== void 0 && config.darkTheme ? " border-[2px] border-primary" : "border-black") : "bg-[#EDEEF0] border border-[#e0e1e1] rounded-2xl", " \n        ").concat(className ? className : categoryName == "External" ? "w-[45%] md:w-[47%] lg:w-[30%]" : "xl:w-[300px] lg:w-[300px] card_section md:w-[200px] w-[165px]"),
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex h-full flex-col",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "relative group overflow-hidden",
          children: [/*#__PURE__*/_jsx("img", {
            loading: "lazy",
            src: thumbnailImageUrl ? thumbnailImageUrl : displayImageUrl,
            className: "".concat(categoryName === "External" ? "w-full h-full" : "object-cover w-full h-[165px] md:h-[200px] card_img lg:h-[300px]", " rounded-t-2xl ").concat(isPoints ? "lg:h-[300px]" : "lg:h-[300px]", " "),
            alt: "deal"
          }), !hideVendorLogo && !isRewards && categoryName !== "External" && /*#__PURE__*/_jsx("img", {
            src: vendorLogoUrl,
            className: "absolute top-2 right-2 md:top-3 md:right-3 w-[45px] h-[45px] md:w-[60px] md:h-[60px] rounded-lg shadow-lg",
            alt: "Vendor Logo"
          }), /*#__PURE__*/_jsx("div", {
            className: "animate-shine shine-line group-hover:opacity-30 opacity-0"
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex flex-1 flex-col justify-between  ".concat(isPoints ? "" : "xl:p-4 lg:p-2 p-2", " rounded-b-2xl ").concat(isRewards ? "" : ""),
          children: [!isRewards && /*#__PURE__*/_jsx("p", {
            className: "text-primary uppercase font-bold text-sm pb-1",
            children: vendorName
          }), isRewards && !isPoints && /*#__PURE__*/_jsx("p", {
            className: "text-primary uppercase font-bold text-sm pb-1",
            children: brandName
          }), /*#__PURE__*/_jsx("h1", {
            className: "text-xs md:text-sm lg:text-sm h-[60px] leading-5 ".concat(isPoints && config !== null && config !== void 0 && config.darkMode ? "text-white" : "text-black", " ").concat(isPoints ? "text-center font-semibold text-[12px] lg:text-[16px] xl:p-4 lg:p-2 p-1" : ""),
            children: truncateText(title, {
              // screen size : character limit → { 768 : 85 , 1024 : 100}
              // single value applies to all screen sizes → 100
              1440: 100,
              1280: 90,
              1024: 100,
              768: 90,
              425: 85,
              375: 40,
              360: 35
            })
          }), isPoints && /*#__PURE__*/_jsxs("div", {
            className: " mt-3 border-t-[1px] border-black flex items-center gap-2 lg:gap-4 justify-center px-4 py-3 ".concat(config !== null && config !== void 0 && config.darkTheme ? "bg-black rounded-b-lg" : ""),
            children: [/*#__PURE__*/_jsxs("div", {
              className: "flex items-center gap-1 lg:gap-2",
              children: [/*#__PURE__*/_jsx("span", {
                className: "font-bold text-[14px] lg:text-2xl leading-none ".concat(config !== null && config !== void 0 && config.darkTheme ? "text-white" : "text-primary"),
                children: formattedPoints
              }), /*#__PURE__*/_jsx("div", {
                className: "shrink-0",
                children: /*#__PURE__*/_jsx(Coin, {})
              })]
            }), /*#__PURE__*/_jsx("div", {
              className: "w-[1.5px] h-[32px] shrink-0 flex-none ".concat(config !== null && config !== void 0 && config.darkTheme ? "" : "bg-black"),
              style: config !== null && config !== void 0 && config.darkTheme ? {
                background: config === null || config === void 0 ? void 0 : config.primaryColor
              } : {}
            }), /*#__PURE__*/_jsxs("button", {
              onClick: function onClick(event) {
                event.stopPropagation();
                OnCartClick();
              },
              className: "text-left",
              children: [/*#__PURE__*/_jsx("p", {
                className: "".concat(config !== null && config !== void 0 && config.darkTheme ? "" : "text-black", " font-bold  text-[10px] lg:text-[14px]"),
                style: config !== null && config !== void 0 && config.darkTheme ? {
                  color: config === null || config === void 0 ? void 0 : config.primaryColor
                } : {},
                children: "Redeem"
              }), /*#__PURE__*/_jsx("p", {
                className: "".concat(config !== null && config !== void 0 && config.darkTheme ? "" : "text-black", " font-bold text-[10px] lg:text-[14px]"),
                style: config !== null && config !== void 0 && config.darkTheme ? {
                  color: config === null || config === void 0 ? void 0 : config.primaryColor
                } : {},
                children: "Now"
              })]
            })]
          }), isPriceDrop && /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsxs("h4", {
              className: "text-xs md:text-sm lg:text-sm font-semibold text-primary",
              children: ["MRP ", toIndianRs(productMrp)]
            })
          }), !isPoints && /*#__PURE__*/_jsxs("div", {
            className: "flex justify-between  mt-2  ".concat(isRewards ? "flex-col gap-2" : "flex flex-col-reverse flex-col  lg:flex-row lg:items-center  "),
            children: [/*#__PURE__*/_jsxs("div", {
              className: "flex justify-start",
              children: [!isPoints && /*#__PURE__*/_jsx("button", {
                className: " font-semibold ".concat(config !== null && config !== void 0 && config.darktheme ? config === null || config === void 0 || (_config$deals = config.deals) === null || _config$deals === void 0 || (_config$deals = _config$deals.darkTheme) === null || _config$deals === void 0 ? void 0 : _config$deals.text : isRewards ? "text-gray-700" : "text-primary", " ").concat(isRewards ? " line-through text-xs md:text-sm lg:text-sm" : "text-xs"),
                children: isRewards ? toIndianRs(productMrp) : "Know more >"
              }), isRewards && !isPoints && /*#__PURE__*/_jsx("div", {
                children: /*#__PURE__*/_jsxs("h4", {
                  className: "text-xs md:text-sm lg:text-sm font-semibold ml-2  text-primary",
                  children: ["Buy at ", toIndianRs(99)]
                })
              })]
            }), isRewards === true ? /*#__PURE__*/_jsx("button", {
              onClick: function onClick(event) {
                event.stopPropagation();
                if (rewardStorePoint) {
                  history.push("".concat(rewardsRouteBase, "/").concat(id), {
                    from: "".concat((location === null || location === void 0 ? void 0 : location.pathname) || "").concat((location === null || location === void 0 ? void 0 : location.search) || "")
                  });
                } else if (!itemAdded) {
                  OnCartClick(); // Call only if the button is not already clicked
                } // Prevent event bubbling

                // if (!itemAdded) OnCartClick();
              },
              className: " text-white w-full p-2 mt-1 rounded-md transition duration-200 flex items-center gap-1 justify-center cursor-pointer ".concat(itemAdded || disableCart ? "bg-[#77a0d6]" : "bg-[#16519E]"),
              disabled: disableCart || itemAdded,
              children: rewardStorePoint ? /*#__PURE__*/_jsx("span", {
                className: "text-[11px] md:text-sm lg:text-sm",
                children: "View More Info"
              }) : itemAdded ? /*#__PURE__*/_jsxs(_Fragment, {
                children: [check, " ", /*#__PURE__*/_jsx("span", {
                  className: "text-[11px] md:text-sm lg:text-sm",
                  children: "Added to Gift Basket"
                })]
              }) : /*#__PURE__*/_jsxs(_Fragment, {
                children: [cart, " ", /*#__PURE__*/_jsx("span", {
                  className: "text-[11px] md:text-sm lg:text-sm",
                  children: "Add to Gift Basket"
                })]
              })
            }) : /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsxs("p", {
                className: "".concat(config === null || config === void 0 || (_config$deals2 = config.deals) === null || _config$deals2 === void 0 || (_config$deals2 = _config$deals2.dealLayout) === null || _config$deals2 === void 0 ? void 0 : _config$deals2.listBodyClass, " text-[12px] italic text-gray-900 "),
                children: ["Valid till: ", renderDate(endDate)]
              })
            })]
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(Fireworks, {
      itemAdded: itemAdded,
      redux: redux,
      isPoints: isPoints
    })]
  });
}
export default DealsLayout;